import { render, staticRenderFns } from "./OrderCollect.vue?vue&type=template&id=727eeaa4&"
import script from "./OrderCollect.vue?vue&type=script&lang=js&"
export * from "./OrderCollect.vue?vue&type=script&lang=js&"
import style0 from "./OrderCollect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports